"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validString = exports.validYMD = void 0;
const moment_1 = __importDefault(require("moment"));
const validYMD = date => {
    const ymd = moment_1.default(date, 'YYYY-MM-DD', true);
    const ydm = moment_1.default(date, 'YYYY-DD-MM', true);
    const dmy = moment_1.default(date, 'DD-MM-YYYY', true);
    const mdy = moment_1.default(date, 'MM-DD-YYYY', true);
    const ymd2 = moment_1.default(date, 'YYYY/MM/DD', true);
    const ydm2 = moment_1.default(date, 'YYYY/DD/MM', true);
    const dmy2 = moment_1.default(date, 'DD/MM/YYYY', true);
    const mdy2 = moment_1.default(date, 'MM/DD/YYYY', true);
    // console.log(ymd, ydm, dmy, mdy)
    if (ymd.isValid() ||
        ydm.isValid() ||
        dmy.isValid() ||
        mdy.isValid() ||
        ymd2.isValid() ||
        ydm2.isValid() ||
        dmy2.isValid() ||
        mdy2.isValid()) {
        return true;
    }
    return false;
};
exports.validYMD = validYMD;
const validString = date => {
    const m = moment_1.default(date, moment_1.default.defaultFormat, true);
    if (m.isValid()) {
        return true;
    }
    return false;
};
exports.validString = validString;
//# sourceMappingURL=dateValidationRules.js.map